import primary from "./primary.png";
import topbarLogo from "./topbar-logo.png";

export default {
  primary,
  topbarLogo
};



// WEBPACK FOOTER //
// ./src/assets/brands/png/mhi/index.js